var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_273_4920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.524 17.8251L23.922 17.8242C23.1447 17.8242 22.5146 18.4542 22.5146 19.2314V24.8545C22.5146 25.6316 23.1447 26.2617 23.9219 26.2617H33.8343C32.7489 29.0786 30.723 31.4377 28.1383 32.9366L32.3649 40.2533C39.145 36.3321 43.1534 29.452 43.1534 21.7502C43.1534 20.6536 43.0726 19.8696 42.9109 18.9869C42.788 18.3163 42.2058 17.8251 41.524 17.8251Z",
    fill: "#167EE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.577 34.7104C16.7261 34.7104 12.4912 32.06 10.2168 28.1379L2.90039 32.3551C6.62367 38.8081 13.5986 43.1535 21.577 43.1535C25.4909 43.1535 29.184 42.0997 32.3654 40.2632V40.2532L28.1388 32.9364C26.2055 34.0578 23.9682 34.7104 21.577 34.7104Z",
    fill: "#12B347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3656 40.2636V40.2535L28.139 32.9368C26.2057 34.058 23.9686 34.7107 21.5771 34.7107V43.1539C25.4911 43.1539 29.1844 42.1001 32.3656 40.2636Z",
    fill: "#0F993E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44315 21.5768C8.44315 19.1857 9.09568 16.9487 10.2168 15.0154L2.90033 10.7983C1.05373 13.9697 0 17.6528 0 21.5768C0 25.5007 1.05373 29.1838 2.90033 32.3552L10.2168 28.1381C9.09568 26.2049 8.44315 23.9678 8.44315 21.5768Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.577 8.44315C24.7403 8.44315 27.6459 9.56717 29.9155 11.4369C30.4754 11.8981 31.2891 11.8648 31.802 11.3519L35.7861 7.36776C36.368 6.78586 36.3266 5.83335 35.705 5.2941C31.9025 1.99528 26.955 0 21.577 0C13.5986 0 6.62367 4.34547 2.90039 10.7985L10.2168 15.0156C12.4912 11.0936 16.7261 8.44315 21.577 8.44315Z",
    fill: "#FF4B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9156 11.4369C30.4755 11.8981 31.2894 11.8648 31.8022 11.3519L35.7863 7.36776C36.3681 6.78586 36.3267 5.83335 35.7051 5.2941C31.9026 1.99519 26.9551 0 21.5771 0V8.44315C24.7404 8.44315 27.6461 9.56717 29.9156 11.4369Z",
    fill: "#D93F21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_273_4920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.1538,
    height: 43.1538,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.3893438739d46dba3f7442e715065dd8.svg";
export { ForwardRef as ReactComponent };